import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
function ar(e, t, a = !1) {
  if (r.rr()) return nr.m().refreshFeatureFlags(e, t, a);
}
export function refreshFeatureFlags(r, e) {
  ar(r, e);
}
export default ar;
